import React, { useState } from 'react';
import SalaryData from './salary-data';
import LaborInsuranceData from './labor-insurance-data';
import LaborPensionData from './labor-pension-data';
import NhiData from './nhi-data';
import NhiDependentsData from './nhi-dependents-data';
import IncomeTaxData from './income-tax-data';
import IncomeTaxDependentsData from './income-tax-dependents-data';
import SalarySubjectData from './salary-subject-data';
import {ReactComponent as UserIcon} from '../user.svg';
import {DateTime} from 'luxon';
import Loading from './loading';
import OccupationalInjuryInsurance from './occupational-injury-insurance';
import {useWatch} from 'react-hook-form';

export default function FormContent(props: any) {
  const {
    currentEmployee,
    getInsuranceAmount,
    updateLocale,
    options,
    formProps,
    openSalarySubjectForm,
    presetEffectiveDate,
    initMonthlySubject,
    initHourlySubject,
  } = props;
  const resetSubjectState = useState(false);
  const onBoardingDate = DateTime.fromJSDate(
    new Date(currentEmployee?.employee?.onBoardingDate),
  ).toLocaleString(DateTime.DATE_SHORT);
  const {control, register, reset, formState, trigger} = formProps;
  const shouldPresetEffectiveDate =  useWatch({
    control,
    name: `shouldPresetEffectiveDate`,
    defaultValue: currentEmployee?.shouldPresetEffectiveDate,
  });

  React.useEffect(() => {
    reset(currentEmployee, {
      isSubmitted: formState.isSubmitted,
    });
  }, [currentEmployee]);

  React.useEffect(() => {
    setTimeout(() => {
      if (formState.isSubmitted) {
        trigger();
      }
    }, 200);
  }, [currentEmployee]);

  if (!currentEmployee || options.isLoading) {
    return <Loading />;
  }
  return (
    <div className={'w-[calc(100%-13px-178px)] ml-[192px] mr-[6px]'}>
      <input
        name={`employee.id`}
        hidden
        ref={register}
        defaultValue={currentEmployee.employee.id}
      />
      <input
        name={`employee.name`}
        hidden
        ref={register}
        defaultValue={currentEmployee.employee.name}
      />
      <input
        name={`employee.jobNo`}
        hidden
        ref={register}
        defaultValue={currentEmployee.employee.jobNo}
      />
      <input
        name={`employee.onBoardingDate`}
        hidden
        ref={register}
        defaultValue={currentEmployee.employee.onBoardingDate}
      />
      <input
        name={`shouldPresetEffectiveDate`}
        hidden
        ref={register}
        defaultValue={currentEmployee.shouldPresetEffectiveDate}
      />
      <div className={'h-10 text-lg flex items-center'}>
        <UserIcon />
        <span
          className={'pl-[10px]'}
        >{`${currentEmployee.employee.jobNo}/${currentEmployee.employee.name}`}</span>
      </div>
      <div className="flex gap-[15px]">
        <div>
          <SalaryData
            updateLocale={updateLocale}
            onBoardingDate={onBoardingDate}
            formProps={formProps}
            options={options}
            defaultValues={{
              ...currentEmployee.personalPayroll,
            }}
            resetSubjectState={resetSubjectState}
          />
          <LaborInsuranceData
            updateLocale={updateLocale}
            onBoardingDate={onBoardingDate}
            formProps={formProps}
            options={options}
            defaultValues={currentEmployee.laborInsurance}
            getInsuranceAmount={getInsuranceAmount}
            defaultEmployeeId={currentEmployee.employee.id}
            presetEffectiveDate={presetEffectiveDate}
            shouldPresetEffectiveDate={shouldPresetEffectiveDate}
          />
          <OccupationalInjuryInsurance
            updateLocale={updateLocale}
            onBoardingDate={onBoardingDate}
            formProps={formProps}
            options={options}
            defaultValues={currentEmployee.occupationalInjuryInsurance}
            getInsuranceAmount={getInsuranceAmount}
            defaultEmployeeId={currentEmployee.employee.id}
            presetEffectiveDate={presetEffectiveDate}
            shouldPresetEffectiveDate={shouldPresetEffectiveDate}
          />
          <LaborPensionData
            updateLocale={updateLocale}
            onBoardingDate={onBoardingDate}
            formProps={formProps}
            options={options}
            defaultValues={currentEmployee.retirement}
            getInsuranceAmount={getInsuranceAmount}
            defaultEmployeeId={currentEmployee.employee.id}
            presetEffectiveDate={presetEffectiveDate}
            shouldPresetEffectiveDate={shouldPresetEffectiveDate}
          />
          <NhiData
            updateLocale={updateLocale}
            onBoardingDate={onBoardingDate}
            formProps={formProps}
            options={options}
            defaultValues={currentEmployee.healthInsurance}
            getInsuranceAmount={getInsuranceAmount}
            defaultEmployeeId={currentEmployee.employee.id}
            presetEffectiveDate={presetEffectiveDate}
            shouldPresetEffectiveDate={shouldPresetEffectiveDate}
          />
          <NhiDependentsData
            updateLocale={updateLocale}
            onBoardingDate={onBoardingDate}
            formProps={formProps}
            options={options}
            defaultValues={currentEmployee.dependentsHealthInsurance}
            defaultNHIEnabled={currentEmployee.healthInsurance.enabled}
            presetEffectiveDate={presetEffectiveDate}
            shouldPresetEffectiveDate={shouldPresetEffectiveDate}
          />
          <IncomeTaxData
            updateLocale={updateLocale}
            onBoardingDate={onBoardingDate}
            formProps={formProps}
            options={options}
            defaultValues={currentEmployee.tax}
            presetEffectiveDate={presetEffectiveDate}
            shouldPresetEffectiveDate={shouldPresetEffectiveDate}
          />
          <IncomeTaxDependentsData
            updateLocale={updateLocale}
            onBoardingDate={onBoardingDate}
            formProps={formProps}
            options={options}
            defaultValues={currentEmployee.dependentsTax}
            defaultTaxEnabled={currentEmployee.tax.enabled}
          />
        </div>
        <SalarySubjectData
          updateLocale={updateLocale}
          formProps={formProps}
          options={options}
          defaultValues={{
            ...currentEmployee.personalPayroll,
            ...currentEmployee.payrollSubject,
          }}
          resetSubjectState={resetSubjectState}
          openSalarySubjectForm={openSalarySubjectForm}
          initMonthlySubject={initMonthlySubject}
          initHourlySubject={initHourlySubject}
        />
      </div>
    </div>
  );
}
